import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useStoreActions } from 'easy-peasy';
import LanguageIcon from '@mui/icons-material/Language';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import MainImg from '../../images/main-bg.png';
import Play1 from '../../images/play-1.png';
import Play2 from '../../images/play-2.png';
import { Get } from '../../services/http';
import VideoPop from '../../dialogs/video-pop';

export default function MainPage() {
    const [campaigns, setCampaigns] = React.useState(null);
    const [campaignsOrder, setCampaignsOrder] = React.useState(null);
    const [activeSlide, setActiveSlide] = React.useState(null);
    const getCampaignsList = async () => {
        console.log('campaings: before ');
        const serverUserData = await Get('/api/donation/GetCampaignsList', '');
        console.log('campaings: after', serverUserData.campaigns);
        if (serverUserData.result) {
            serverUserData.campaigns.map((item) => {
                const percent = (item.sumDonated / item.donatedGoal) * 100;
                item.percent = percent ? percent.toString() + '%' : '0%';
                return item;
            });
            serverUserData.campaigns.map((item) => { item.class = 'slider-multimple__item'; return item; });
            setCampaigns(serverUserData.campaigns);
            setCampaignsOrder(serverUserData.campaigns);
            setActiveSlide(serverUserData.campaigns[0].slug);
        }
    };

    const openNext = () => {
        // const lastEl = campaigns[(campaigns.length - 1)];
        const firstEl = campaigns[0];
        const splicedCampaigns = campaigns.filter((item, index) => index !== 0); // return all slides without the first one with index 0
        const newCampaigns = [...splicedCampaigns];
        newCampaigns.push(firstEl);
        newCampaigns.map((item) => { item.class = 'slider-multimple__item slide-left'; return item; });
        setCampaigns(newCampaigns);
        setActiveSlide(firstEl.slug);
        setTimeout(() => {
            const activeCampaigns = newCampaigns.map((item) => { item.class = 'slider-multimple__item slide-left active'; return item; });
            console.log('activeCampaigns', activeCampaigns);
            setCampaigns(activeCampaigns);
        }, 30);
    };

    const openPrevious = () => {
        const lastIndex = campaigns.length - 1;
        const lastEl = campaigns[lastIndex];
        const splicedCampaigns = campaigns.filter((item, index) => index !== lastIndex);
        const newCampaigns = [lastEl, ...splicedCampaigns];
        newCampaigns.map((item) => { item.class = 'slider-multimple__item slide-right'; return item; });
        setCampaigns(newCampaigns);
        setActiveSlide(lastEl.slug);
        setTimeout(() => {
            const activeCampaigns = newCampaigns.map((item) => { item.class = 'slider-multimple__item slide-right active'; return item; });
            console.log('activeCampaigns', activeCampaigns);
            setCampaigns(activeCampaigns);
        }, 30);
    };

    React.useEffect(() => {
        getCampaignsList();
    }, []);
    return (
        <>
            <Helmet>
                <title>World of Tzedaka - Main</title>
            </Helmet>
            <main className="main main--null bg-color">
                <section className="">
                    <div>
                        <h1 style={{ paddingTop: '20px' }} className="mb2-0 center-text color-1 weight-500 f-67 rubik f-normal _anim-items _anim-no-hide _fadeDown" data-animate-delay="03">
                            WELCOME TO THE
                            <span style={{ display: 'block' }} className="mb2-0 rubik weight-700 f-80 f-normal color-5">WORLD OF TZEDAKA</span>
                        </h1>
                        <div class="main-hero-info-buttons head-section" style={{ height: '597.67px', backgroundImage: `url(${MainImg})` }}>
                            <div className="text-center-bg">
                                <div className="flex align-items-center space-between show-700">
                                    <div style={{ marginTop: '7px' }}>
                                        {/* <a href="/about-us">
                                            <img src={Play1} alt="imag" className="card-1-style" />
                                        </a> */}
                                        <VideoPop image = {<img src={Play1} alt="imag" className="card-1-style" />} />
                                    </div>
                                    <div className="left-space">
                                        {/* <a href="/about-us">
                                            <img src={Play2} alt="imag" className="card-2-style" />
                                        </a> */}
                                        <VideoPop image = {<img src={Play2} alt="imag" className="card-2-style" />} />
                                    </div>
                                </div>
                                <div className="show0-699">
                                    <div>
                                        {/* <a href="/about-us">
                                            <img src={Play1} alt="imag" className="card-1-style" />
                                        </a> */}
                                        <VideoPop image = {<img src={Play1} alt="imag" className="card-1-style" />} />

                                    </div>
                                    <div>
                                        {/* <a href="/about-us">
                                            <img src={Play2} alt="imag" className="card-2-style" />
                                        </a> */}
                                        <VideoPop image = {<img src={Play2} alt="imag" className="card-2-style" />} />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="welcome__path _anim-items _anim-no-hide _fade" data-animate-delay="06"></div>
                </section>
                <section className="about-us section">
                    <div className="container">
                        <div className="section__head">
                            <p style={{ paddingTop: 30 }} className="rubik f-normal weight-600 color-1 f-50 center-text  _anim-items _fadeScale" data-animate-delay="01">About Us</p>
                        </div>

                        <div className="about-us__text _anim-items _fadeDown" data-animate-delay="03">
                            <p className="weight-400 roboto f-normal f-18 center-text color-4"><span className="weight-600 color-5">One of our goals is to enable any individual or organization to raise money for their specific cause.</span><br />
                                <span style={{ display: 'inline-block', margin: '20px 0px' }}>
                                    We help individuals from Eretz Yisroel coming to the United States to raise money for themselves or someone else, families in Eretz Yisrael and the United States going through a tragedy, and organizations/Yeshivas around the world. <br />
                                </span>
                                <span className="weight-600 color-5">We offer all the necessary resources and services</span> needed to fundraise for any cause efficiently and successfully.
                            </p>
                        </div>
                        <div className="about-us__button _anim-items _fade" data-animate-delay="05">
                            <a href="/about-us" className="">
                                <button className="btn-red rubik weight-400 f-normal f-20 text-white" type="button" style={{ marginBottom: '30px', borderBottom: '2px solid #000000', width: '200px', background: '#1979BE' }}>Read More {'>'}</button>
                            </a>
                        </div>
                    </div>
                </section>
                <section className="about-us section">
                    <div className="bg-white" style={{ paddingTop: '65px', paddingBottom: '30px' }}>
                        <div className="section__head">
                            <p style={{ paddingBottom: '70px' }} className="rubik f-normal weight-600 color-1 f-50 center-text  _anim-items _fadeScale" data-animate-delay="01">General Donation</p>
                        </div>

                        <div className="about-us__text _anim-items _fadeDown" data-animate-delay="03">
                            <p className="roboto f-normal weight-400 color-4 f-18"><span className="weight-600 color-5">As you can see on our campaign page, we have many campaigns that we run to help those in need.</span><br />
                                <span style={{ display: 'inline-block', marginTop: '20px' }}>
                                    There are also families that do not want to publicize their  name/story (even though they are just as heart-wrenching as some of our other campaigns), so we raise funds for them via our general donation button below. Some of these families are not getting the help that they desperately need because of fear of embarrassment. They may be your neighbor or someone else you know. If you would like to be part of our matan b’saiser fund, <br />
                                    <span className="weight-600 color-5">please click the general donation button below.</span>
                                </span>
                            </p>
                            <a href="https://n.worldoftzedaka.org/campaign/126">
                                <button className="btn-red text-white weight-400 f-30 rubik f-normal w-40" type="button" style={{ background: '#1D1E1D', borderBottom: '3px solid #1979BE' }}>DONATE NOW!</button>
                            </a>
                        </div>
                    </div>
                </section>
                <section className="services section">
                    <div className="container">
                        <div className="section__head">
                            <h2 className="rubik f-normal weight-600 color-1 f-54 center-text  _anim-items _fadeScale" data-animate-delay="01" style={{ marginTop: '50px', marginBottom: '50px' }}><span>Our Service</span></h2>
                        </div>

                        <div className="services-wrap">
                            <div className="services-wrap__item _anim-items _fadeDown" data-animate-delay="02">
                                <div className="item-service bg-white" style={{ padding: '5px' }}>
                                    <div className="item-service__img"><img src="img/service-1.png" alt="" /></div>
                                    <div className="weight-400 roboto f-normal f-16-mob center-text color-5">Mailbox Service</div>
                                </div>
                            </div>
                            <div className="services-wrap__item _anim-items _fadeDown" data-animate-delay="03">
                                <div className="item-service bg-white" style={{ padding: '5px' }}>
                                    <div className="item-service__img"><img src="img/service-2.png" alt="" /></div>
                                    <div className="weight-400 roboto f-normal f-16-mob center-text color-5">Mailing service</div>
                                </div>
                            </div>
                            <div className="services-wrap__item _anim-items _fadeDown" data-animate-delay="04">
                                <div className="item-service bg-white" style={{ padding: '5px' }}>
                                    <div className="item-service__img"><img src="img/service-3.png" alt="" /></div>
                                    <div className="weight-400 roboto f-normal f-16-mob center-text color-5">Personal website <br /> Building service</div>
                                </div>
                            </div>
                            <div className="services-wrap__item _anim-items _fadeDown" data-animate-delay="05">
                                <div className="item-service bg-white" style={{ padding: '5px' }}>
                                    <div className="item-service__img"><img src="img/service-4.png" alt="" /></div>
                                    <div className="weight-400 roboto f-normal f-16-mob center-text color-5">Mass fundraising <br /> Campaign building service</div>
                                </div>
                            </div>
                            <div className="services-wrap__item _anim-items _fadeDown" data-animate-delay="06">
                                <div className="item-service bg-white" style={{ padding: '5px' }}>
                                    <div className="item-service__img"><img src="img/service-5.png" alt="" /></div>
                                    <div className="weight-400 roboto f-normal f-16-mob center-text color-5">Telephony service</div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="services__path _anim-items _fade" data-animate-delay="02"></div>

                </section>

                {/* <section className="campings-sec section">
                <div className="container">
                    <div className="section__head">
                        <h2 className="section__title _anim-items _fadeScale" data-animate-delay="01"><span>Campaings</span></h2>
                    </div>

                    <div className="campings-sec__slider slider-multimple slider-multimple--pagination _anim-items _fade" data-animate-delay="03">
                        <div className="slider-multimple__container">
                            <div className="slider-multimple__wrapper">
                                {campaigns?.map((item) => (
                                    <div className={item.class}>
                                        <div className="campaigns__item">
                                            <a href={'/campaign/' + item.id} className="item-campaign">
                                                <div className="item-campaign__img"><img src={item.mainImage} alt="" /></div>
                                                <div className="item-campaign__body">
                                                    <div className="item-campaign__title">{item.name}</div>
                                                    <div className="item-campaign__text">{item.shortText}</div>
                                                    <div className="item-campaign__progress progress">
                                                        <div className="progress__track" style={{ width: item.percent }}></div>
                                                    </div>
                                                    <div className="item-campaign__icons-grid icons-grid">

                                                        <div className="icons-grid__item">

                                                            <div className="icons-grid__title">Fund Raised: <span>${item.sumDonated.toFixed(2)}</span></div>
                                                        </div>
                                                        <div className="icons-grid__item">

                                                            <div className="icons-grid__title">Raised Percent: <span>{parseFloat(item.percent).toFixed(2) + '%'}</span></div>
                                                        </div>
                                                        <div className="icons-grid__item">

                                                            <div className="icons-grid__title">Supporters: <span>{item.supportersNum}</span></div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="slider-multimple__prev" onClick={openPrevious}><img src="img/swiper-arrow.png" alt="" /></div>
                        <div className="slider-multimple__next" onClick={openNext}><img src="img/swiper-arrow.png" alt="" /></div>
                        <div className="slider-multimple__pagination">
                            {campaignsOrder?.map((item) => (<div className={activeSlide === item.slug ? 'slider-multimple__bullet _active' : 'slider-multimple__bullet'}></div>))}
                        </div>
                    </div>

                </div>
            </section> */}
                <section className="contacts bg-white" style={{ paddingTop: 20, paddingBottom: 20 }}>
                    <h1 className="contacts__title _anim-items _fadeScale rubik f-normal weight-600 f-54 color-1" style={{ marginTop: '20px' }} data-animate-delay="01">Contact Us</h1>

                    <div className="contacts__path">
                        <div className="container">
                            <div className="contacts-wrap">
                                <div className="contacts-wrap__item _anim-items _fadeRight flex" data-animate-delay="03">
                                    <div className="contacts-wrap__icon">
                                        <LanguageIcon style={{ fontSize: '20px', color: 'red' }} />
                                    </div>
                                    <div className="contacts-wrap__text weight-400 f-normal roboto f-16" style={{ marginTop: 10, marginLeft: 10 }}>
                                        <span className="weight-500">Mail:</span> P.o. Box 1003,Lakewood NJ 08701
                                    </div>
                                </div>
                                <div className="contacts-wrap__item _anim-items _fadeRight flex" data-animate-delay="04">
                                    <div className="contacts-wrap__icon">
                                        <LocationOnIcon style={{ fontSize: '20px', color: 'red' }} />
                                    </div>
                                    <div className="contacts-wrap__text weight-400 f-normal roboto f-16" style={{ marginTop: 10, marginLeft: 10 }}>
                                        <span className="weight-500">Address:</span>
                                        16 Bridgewood Ave,
                                        Lakewood NJ 08701
                                    </div>
                                </div>
                                <div className="contacts-wrap__item _anim-items _fadeRight flex" data-animate-delay="05">
                                    <div className="contacts-wrap__icon">
                                        <CallIcon style={{ fontSize: '20px', color: 'red' }} />
                                    </div>
                                    <div className="contacts-wrap__text weight-400 f-normal roboto f-16" style={{ marginTop: 10, marginLeft: 10, fontSize: '14px' }}>
                                        <span className="weight-500">Call or Text: </span>
                                        732-307-8182 <br />
                                        <span className="weight-500">WhatsApp:</span> Click here
                                    </div>
                                </div>
                                <div className="contacts-wrap__item _anim-items _fadeRight flex" data-animate-delay="06">
                                    <div className="contacts-wrap__icon">
                                        <EmailIcon style={{ fontSize: '20px', color: 'red' }} />
                                    </div>
                                    <div className="contacts-wrap__text weight-400 f-normal roboto f-16" style={{ marginTop: 10, marginLeft: 10, fontSize: '14px' }}>
                                        <span className="weight-500">Email:</span>
                                        info@tomcheitzedaka.org
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

            </main>
        </>
    );
}
